
export default {
    "global.upload.file": "global.common.select_attachment",
    "global.datepicker.year": "global.common.year",
    "global.upload.complete": "global.common.finished",
    "global.modal.confirm": "global.common.update_OK",
    "global.select.noDataText": "global.table.noDataText",
    "global.input.noDataText": "global.table.noDataText",
}

